import { workflowSuggestionSchema } from "../../shared/workflowSuggestion";
import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text, variantStyles } from "../components/Text";

function WorkflowSuggestionHeader({
  toolUse,
  result,
  interrupted,
}: ToolUseProps) {
  const parsed = workflowSuggestionSchema.safeParse(toolUse.input);
  return (
    <ToolStatus
      icon="3b-mark"
      text={
        !result
          ? "Considering a reusable workflow…"
          : result.isError || !parsed.success
            ? "Couldn’t update workflow suggestion"
            : parsed.data.suggestion
              ? `Suggested ${parsed.data.suggestion.title}`
              : "Removed workflow suggestion"
      }
      pending={!result && !interrupted}
    />
  );
}

function WorkflowSuggestionBody({ toolUse }: ToolUseProps) {
  const parsed = workflowSuggestionSchema.safeParse(toolUse.input);
  const suggestion = parsed.success ? parsed.data.suggestion : null;
  if (!suggestion) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Text variant="text-small">{suggestion.reason}</Text>
      <Text variant="text-small" color="var(--text-secondary)">
        Inputs: {suggestion.inputs}
        <br />
        Trigger: {suggestion.trigger}
      </Text>
      <ol
        style={{ ...variantStyles["text-small"], margin: 0, paddingLeft: 20 }}
      >
        {suggestion.steps.map((step, index) => (
          // oxlint-disable-next-line react/no-array-index-key -- steps are a fixed ordered list with no item state
          <li key={index}>{step}</li>
        ))}
      </ol>
    </div>
  );
}

export const setWorkflowSuggestion: ChatTool = {
  name: "setWorkflowSuggestion",
  Header: WorkflowSuggestionHeader,
  Body: WorkflowSuggestionBody,
};
